var map = {
	"./01_Su_frame of reference I and II__Ausstellungsansicht.webp": 3329,
	"./05_Su_Mori_Ausstellungsansicht.webp": 690,
	"./08_SU_water sleep II Akaike River Under Xizang Road_Still.webp": 3852,
	"./09_Su_hibernatemode_Ausstellungsansicht.webp": 549,
	"./12_Su_Tidal Variations_Ausstellungsansicht.webp": 2024,
	"./16_Su_Paeonia Drive__Ausstellungsansicht.webp": 3468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1721;